import AdminTemplate from "../../Templates/Admin";

const AdminPage = () => {
  return (
    <>
      <AdminTemplate />
    </>
  );
};

export default AdminPage;
